/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Font_Color_LabelInputs */

const en_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const fr_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur`)
};

const de_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

const it_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore`)
};

const ru_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет`)
};

const es_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const zh_cn2_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色`)
};

const ja_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色`)
};

const hi_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रंग`)
};

const pt_pt2_image_export_font_color_label = /** @type {(inputs: Image_Export_Font_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Image_Export_Font_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_font_color_label = /** @type {((inputs?: Image_Export_Font_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Font_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_font_color_label(inputs)
	if (locale === "de") return de_image_export_font_color_label(inputs)
	if (locale === "it") return it_image_export_font_color_label(inputs)
	if (locale === "ru") return ru_image_export_font_color_label(inputs)
	if (locale === "es") return es_image_export_font_color_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_font_color_label(inputs)
	if (locale === "ja") return ja_image_export_font_color_label(inputs)
	if (locale === "hi") return hi_image_export_font_color_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_font_color_label(inputs)
	return en_image_export_font_color_label(inputs)
});